import React from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
  } from '../Lib/react-accessible-accordion/accordian/es';
  import '../Lib/react-accessible-accordion/styles/fancy-example.css';
  import "../../Desktop/FAQpage/FAQPage.css";
  import {Accordions} from "../../static/data/Accordion.js";


//   function App() {
//     return <FQQPage {...AccordionData} />;
//   }

//   export default App;

  export default function FQQPage(props) {
    // const {
    //   frame1590Props,
    //   frame15902Props,
    //   frame15903Props,
    //   frame15904Props,
    //   frame15905Props,
    //   frame15906Props,
    //   text29
    // } = props;

    return (
        <Accordion>
            {
                Accordions.map( item => 
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                            <div className="faqpd-frame-159">
                                <div className="faqpd-text-3 faqpd-valign-text-middle faqpd-typographyheadlineh4-extrabold-24">
                                    {item.question}
                                </div>
                            </div>
                            </AccordionItemButton>
                        </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p className="faqpd-text-29 faqpd-typographybody16-regular">
                                    {item.answer}
                                </p>
                            </AccordionItemPanel>
                    </AccordionItem>
                )
            }
        {/* <AccordionItem>
            <AccordionItemHeading>
                <AccordionItemButton>
                <Frame15905 text102={frame1590Props.text102}  />
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
            <p className="faqpd-text-29 faqpd-typographybody16-regular">{text29}</p>
            </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
            <AccordionItemHeading>
                <AccordionItemButton>
                <Frame15905 text102={frame15902Props.text102}  />
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
            <p className="faqpd-text-29 faqpd-typographybody16-regular">{text29}</p>
            </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
            <AccordionItemHeading>
                <AccordionItemButton>
                <Frame15905 text102={frame15903Props.text102}  />
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
            <p className="faqpd-text-29 faqpd-typographybody16-regular">{text29}</p>
            </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
            <AccordionItemHeading>
                <AccordionItemButton>
                <Frame15905 text102={frame15904Props.text102}  />
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
            <p className="faqpd-text-29 faqpd-typographybody16-regular">{text29}</p>
            </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
            <AccordionItemHeading>
                <AccordionItemButton>
                <Frame15905 text102={frame15905Props.text102}  />
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
            <p className="faqpd-text-29 faqpd-typographybody16-regular">{text29}</p>
            </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
            <AccordionItemHeading>
                <AccordionItemButton>
                <Frame15905 text102={frame15906Props.text102}  />
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
            <p className="faqpd-text-29 faqpd-typographybody16-regular">{text29}</p>
            </AccordionItemPanel>
        </AccordionItem> */}
    </Accordion>
    );
}
